export default __webpack_public_path__ + "68eb4527b7f5987d378e21592caa360e.png";